<div *ngIf="itemConfig.alreadyOwn; else acquering">
    <h3 name="subscriptionTitle8" *ngIf="allowNotSavePayment">
        {{'REGISTRATION.STEP.PAYMENT.ALREADY_OWN_WATCH.TITLE' | translate}}</h3>
    <ul *ngIf="allowNotSavePayment" class="row no-margin-padding">
        <li name="payment-method-saved" class="col-md-6 unstyle">
            <ng-container *ngTemplateOutlet="formField;context:{option:saved }">
            </ng-container>
        </li>
        <li name="payment-method-none" class="col-md-6 unstyle">
            <ng-container *ngTemplateOutlet="formField;context:{option:none }">
            </ng-container>
        </li>
    </ul>
    <div *ngIf="currentSubscription && currentSubscription.name===saved.name">
        <app-proceed-payment (applyDiscountCode)="updateDiscount($event)" (previousPage)="previous()"
            (proceedPayment)="updatePaymentData($event)" (additionalInfoChange)="updateAdditionalInfo($event)"
            [subscription]="currentSubscription" [equipmentOptions]="options"></app-proceed-payment>
    </div>
</div>
<ng-template #acquering>
    <h3 name="subscriptionTitle7">{{'REGISTRATION.STEP.PAYMENT.IS_ACQUERING_WATCH.TITLE' | translate}}</h3>
    <ul class="row no-margin-padding">
        <li name="payment-method-economy" class="col-md-6 unstyle">
            <ng-container *ngTemplateOutlet="formField;context:{option:economy }">
            </ng-container>
        </li>
        <li name="payment-method-liberty" class="col-md-6 unstyle">
            <ng-container *ngTemplateOutlet="formField;context:{option:liberty }">
            </ng-container>
        </li>
    </ul>
    <h4 class="center"><a href="https://www.co-assist.fr/contact/"
            target="_blank">{{'REGISTRATION.STEP.PAYMENT.IS_ACQUERING_WATCH.NOT_METROPOLITAN' | translate}}</a></h4>
    <h4 class="center">
        <mat-icon class="secure-payment">lock</mat-icon>{{'REGISTRATION.STEP.PAYMENT.SECURE_PAYMENT'|translate}}
        <img class="pci-logo" src="assets/images/logos/paymentBrands/pci-dss-logo.png" alt="PCI compliance">
    </h4>
    <div *ngIf="currentSubscription && currentSubscription.name===economy.name">
        <app-proceed-payment (applyDiscountCode)="updateDiscount($event)" (previousPage)="previous()"
            (taxCreditChange)="updateTaxCreditChange($event)" (proceedPayment)="updatePaymentData($event)"
            (additionalInfoChange)="updateAdditionalInfo($event)" [subscription]="currentSubscription"
            [equipmentOptions]="options"></app-proceed-payment>
    </div>
    <div *ngIf="currentSubscription && currentSubscription.name===liberty.name">
        <app-proceed-payment (applyDiscountCode)="updateDiscount($event)" (previousPage)="previous()"
            (taxCreditChange)="updateTaxCreditChange($event)" (proceedPayment)="updatePaymentData($event)"
            (additionalInfoChange)="updateAdditionalInfo($event)" [subscription]="currentSubscription"
            [equipmentOptions]="options"></app-proceed-payment>
    </div>
    <div *ngIf="!currentSubscription" class="col-md-12">
        <button mat-stroked-button color="primary" class="pull-left" style="margin-right: 3%" (click)="previous()">
            {{'COMMON.BACK' | translate}}
        </button>
    </div>
</ng-template>

<ng-template #formField let-option="option">
    <div (click)="next(option.name, itemConfig.alreadyOwn)" class="panel-choice row">
        <div class="header center col-md-12"
            [class.selected]="currentSubscription && currentSubscription.name===option.name.toLowerCase()">
            <h3>{{'REGISTRATION.STEP.PAYMENT.'+cleanSubscriptionName(option.name)+'.TITLE' | translate}}</h3>
            <h4>{{'REGISTRATION.STEP.PAYMENT.'+cleanSubscriptionName(option.name)+'.SUBTITLE' | translate}}</h4>
        </div>
        <div class="pricing center col-md-12">
            <h2>{{'REGISTRATION.STEP.PAYMENT.'+cleanSubscriptionName(option.name)+'.PRICING' | translate}}</h2>
        </div>
        <div class="description col-md-12">
            <ul>
                <li *ngFor="let line of option.description">
                    {{'REGISTRATION.STEP.PAYMENT.DESCRIPTION.'+line | translate}}
                </li>
            </ul>
        </div>
    </div>
</ng-template>